import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "./../index";
import { Modal, Button } from "antd";
import IDong from "./../../../assets/suc-khoe-vang/iDong.png";
import IViewDetail from "../../../assets/view-detail.svg";
import Helper from "./../../../extra/helper";
import BenefitDetails from "./modalBenifitsDetail";
import { Animated } from "react-animated-css";

const ModalBenifit = (props) => {
  const { dataIsu, goStep, arrItem } = useContext(AuthContext);
  const [openDetail, setOpenDetail] = useState(false);
  const benefits = Helper.Benefits[+dataIsu?.packageId - 1];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handCancel = () => {
    setOpenDetail(false);
  };

  return (
    <div style={{ fontSize: 14 }}>
      <BenefitDetails open={openDetail} handleCancel={handCancel} />
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "95%",
        }}
        centered={true}
        footer={false}
        closable={false}
        open={props.open}
        onCancel={props.handleCancel}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <div
          style={{
            display: "flex",
            padding: "13px 16px",
            background: "#ffffff",
            borderRadius: 8,
            alignItems: "center",
            marginBottom: 10,
            position: "sticky",
            top: 0,
          }}
        >
          <div style={{ marginRight: 10 }}>
            <img
              src={arrItem[+dataIsu?.packageId - 1]?.icon}
              style={{ width: 67, height: 71 }}
            />
          </div>
          <div style={{ width: "100%" }}>
            <div style={{ fontWeight: 600, color: "#009B4B" }}>
              {arrItem[+dataIsu?.packageId - 1]?.title}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Phí bảo hiểm:</span>
              <span style={{ fontWeight: 500, color: "#009B4B" }}>
                {Helper._formatMoney(arrItem[+dataIsu?.packageId - 1]?.fee)} VNĐ
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Thời hạn BH</span>
              <span>1 năm</span>
            </div>
            <div
              onClick={() => setOpenDetail(true)}
              style={{
                background: "#FB7800",
                fontWeight: 600,
                fontSize: 14,
                color: "#fff",
                padding: "6px 10px",
                textAlign: "center",
                borderRadius: 8,
                marginTop: 5,
                display: "flex",
                gap: 10,
                justifyContent: "center",
              }}
            >
              <img src={IViewDetail} />
              Xem chi tiết
            </div>
          </div>
        </div>
        <div>
          <div style={{ padding: "0px 10px" }}>
            <div style={{ fontWeight: "bold" }}>Quyền lợi chính</div>
            <table style={{ width: "100%", marginTop: 10 }}>
              <tr>
                <th
                  style={{
                    width: "75%",
                    textAlign: "center",
                    borderRadius: "10px 0px 0px 0px",
                  }}
                >
                  Quyền lợi
                </th>
                <th
                  style={{
                    textAlign: "center",
                    borderRadius: "0px 10px 0px 0px",
                  }}
                >
                  Số tiền BH (VNĐ)
                </th>
              </tr>
              <tr>
                <td style={css.classTdleft}>
                  1. Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do tai nạn
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold"}}>
                  {benefits?.ql1}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>
                  2. Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do bệnh
                </td>
                <td style={css.classTdrigth}>
                  {benefits?.ql2}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>3. Chi phí y tế do tai nạn</td>
                <td style={css.classTdrigth}>
                  {benefits?.ql3}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>4. Bảo hiểm điều trị nội trú, phẫu thuật do bệnh</td>
                <td style={css.classTdrigth}>
                  {benefits?.ql4}
                </td>
              </tr>
            </table>
          </div>
          <div style={{ padding: "0px 10px" }}>
            <div style={{ fontWeight: "bold", marginTop: 10 }}>
              Quyền lợi bổ sung
            </div>
            <table style={{ width: "100%", marginTop: 10 }}>
              <tr>
                <th
                  style={{
                    width: "75%",
                    textAlign: "center",
                    borderRadius: "10px 0px 0px 0px",
                  }}
                >
                  Quyền lợi
                </th>
                <th
                  style={{
                    textAlign: "center",
                    borderRadius: "0px 10px 0px 0px",
                  }}
                >
                  Số tiền BH (VNĐ)
                </th>
              </tr>
              <tr>
                <td style={css.classTdleft}>
                  1. Thai sản (Không bao gồm chi phí khám thai định kỳ, áp dụng
                  đồng chi trả)
                </td>
                <td style={css.classTdrigth}>
                  {dataIsu?.additional_01?.[0]===1?benefits?.qlbs1: "Không hỗ trợ"}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>2. Bảo hiểm điều trị ngoại trú</td>
                <td style={css.classTdrigth}>
                  {dataIsu?.additional_02?.[0]===1?benefits?.qlbs2: "Không hỗ trợ"}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>3. Nha khoa (áp dụng đồng chi trả)</td>
                <td style={css.classTdrigth}>
                  {dataIsu?.additional_03?.[0]===1?benefits?.qlbs3: "Không hỗ trợ"}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>4. Trợ cấp nằm viện do tai nạn ( tối đa 60 ngày/năm)</td>
                <td style={css.classTdrigth}>
                  {dataIsu?.additional_04?.[0]===1?benefits?.qlbs4: 0}
                </td>
              </tr>
              <tr>
                <td style={css.classTdleft}>5. Dịch vụ bảo lãnh viện phí</td>
                <td style={css.classTdrigth}>
                  {benefits?.qlbs5}
                </td>
              </tr>
            </table>
          </div>
          <Animated
            animationIn="fadeInUp"
            animationInDuration={500}
            isVisible={true}
            style={{ width: "100%", position: "sticky", bottom: 0 }}
          >
            <div style={css.boxbtn}>
              <div style={css.divFlex}>
                <Button
                  onClick={() => props.handleCancel()}
                  style={css.btnBack}
                  type="#009B4B"
                >
                  Quay lại
                </Button>
                <Button
                  onClick={() => goStep(3)}
                  htmlType="submit"
                  style={css.btnNext}
                  type="#009B4B"
                >
                  Tiếp tục
                </Button>
              </div>
            </div>
          </Animated>
        </div>
      </Modal>
    </div>
  );
};

const css = {
  btnBack: {
    color: "#009B4B",
    background: "#FFF",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  btnNext: {
    color: "#FFF",
    background: "#009B4B",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
  },
  boxbtn: {
    bottom: 0,
    background: "#fff",
    borderRadius: "16px 16px 0px 0px",
    boxShadow: "0px -4px 8px 0px #0000001A",
    padding: "15px 10px",
    marginTop: 10,
  },
  divFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  classTdrigth:{ textAlign: "center", fontWeight: "bold" },
  classTdleft:{ textAlign: "justify" }

};

export default ModalBenifit;
